import { reservationAxios } from '../../../core/rest/axios';
export async function loadActivitiesList(branchId) {
    return reservationAxios.get('/cinnosti', { params: { pobockaId: branchId } })
        .then((response) => response.data);
}
